import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { GetMemo, MemoError } from "store/actions";


 import {
   RavenAgTable
 } from "../../components/Common/CombinedComponents";

 import {
  getDateTime
} from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

class MemoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordList: [],
      recordcolumns: [
        {
          headerName: this.props.t("logDateTime"),
          field: "logDateTime",
          filter: "agDateTimeColumnFilter",
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
          minWidth: 175,
        },
        {
          headerName: this.props.t("type"),
          field: "objectStateDesc",
          minWidth: 100,
        },
        {
          headerName: this.props.t("userName"),
          field: "userName",
        minWidth: 150,
        },
        {
          headerName: this.props.t("applicationName"),
          field: "applicationName",
          minWidth: 100,
        },
        {
          headerName: this.props.t("oldValue"),
          field: "originalValue",
          minWidth: 150,
        },
        {
          headerName: this.props.t("currentValue"),
          field: "currentValue",
          minWidth: 150,
        },
        {
          headerName: this.props.t("Description"),
          field: "description",
          minWidth: 500,
        }
      ]

    };
  }
  componentDidMount() {
    const { recordList} =
      this.props;  
    this.setState({ recordList });
  }
  componentDidUpdate(prevProps) {
    const { record , onGetRecordList} =
      this.props;
    if (prevProps.record !== this.props.record) {
      onGetRecordList(record.objectGuid);
    }
  }

  render() {
     const { recordList } = this.props;
    return (
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={false}
          size="xl"
        >
          <ModalBody>
            <Row>
              <Col lg={12}>
                <div className="modal-body" style={{ fontSize: "1.1em" }}>
                 <RavenAgTable
                      actionItems={false}
                      breadCrumbTitle={this.props.t("memoList")}
                      exportOption={true}
                      recordcolumns={this.state.recordcolumns}
                      recordList={recordList}
                    /> 
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("close")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>        
    );
  }
}

MemoModal.propTypes = {
  recordList: PropTypes.array,
  onGetRecordList: PropTypes.func,
  onCloseClick: PropTypes.func,
  record: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};
const mapStateToProps = ({ memoModal }) => ({
  recordList: memoModal.recordList,
  error: memoModal.error,
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList:  guid => dispatch(GetMemo(guid)),
  apiError: error => dispatch(MemoError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(MemoModal));
